
import React from 'react'
import creative from '../../images/creative.png'
import travel from '../../images/travel.png'
import doctors from '../../images/doctors.png'
import volunteer from '../../images/volunteer.png'
export const projectsData=[
    {
        img:creative,
        title:"Creative Agency - A Service Provider Organization",
        description:"A single page application where people can order any service and admin can add a new service",
        technology:[ "React.js", "Node.js",  "Express.js", "MongoDB"],
        liveLink:"https://amazing-kowalevski-800403.netlify.app",
        clientRepo:"https://github.com/Tareqweb/creative-agency-client",
        serverRepo:"https://github.com/Tareqweb/creative-agency-server"
    },
    {
        img:doctors,
        title:"Doctors Portal - Virtual Service for Patients",
        description:"Patient can book an appoinment and doctors check this appoinment and add a prescription",
        technology:[ "React.js", "Node.js",  "Express.js", "MongoDB"],
        liveLink:" https://inspiring-bohr-3424d7.netlify.app",
        clientRepo:" https://github.com/Tareqweb/Doctors-portal-client",
        serverRepo:"https://github.com/Tareqweb/Doctors-portal-server"
    },
    {
        img:travel,
        title:"Travel Guru - Best travel agency in Bangladesh",
        description:"A single page application for booking a travelling point and a hotel",
        technology:["React.js", "Firebase", "Material UI", "Map"],
        liveLink:"https://wonderful-johnson-992add.netlify.app",
        clientRepo:"https://github.com/Tareqweb/travel-guru-app",
        serverRepo:""
    },
    {
        img:volunteer,
        title:"Volunteer Network - Do something for people",
        description:"People can participate in any volunteer for helping something",
        technology:[ "React.js", "Node.js",  "Express.js", "MongoDB"],
        liveLink:"",
        clientRepo:"https://github.com/Tareqweb/volunteer-network-client-site",
        serverRepo:"https://github.com/Tareqweb/volunteer-network-server-site"
    },
]

